import script from "./SeasonsStory.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeasonsStory.vue?vue&type=script&setup=true&lang=ts"

import "./SeasonsStory.vue?vue&type=style&index=0&id=042d972e&lang=less"

const __exports__ = script;

export default __exports__